import React from 'react'
import SwitchSelector from 'react-switch-selector'
import classNames from 'classnames'
import { MdOutlineAutoMode } from 'react-icons/md'

import { ACR_SWITCH_OPTIONS } from '../helpers/constants'

const AutoCreditReplenishmentCard = ({ acrData }) => {
  if (!acrData) return null

  const isEnabled = acrData.status === 'enabled'
  
  return (
    <div className="acr-card">
      <div className="acr-card__layout">
        <div className="acr-card__icon">
          <MdOutlineAutoMode
            size={18}
            color="#666"
          />
        </div>
        <div className="acr-card__content">
          <div className="acr-card__header">
            <div className="acr-card__title-wrapper">
              <span className="acr-card__title">
                Auto Credit Replenishment
              </span>
            </div>
            <div
              className={classNames(
                'acr-card__switch',
                {
                  'acr-card__switch--enabled': isEnabled,
                  'acr-card__switch--disabled': !isEnabled
                }
              )}
            >
              <SwitchSelector
                options={ACR_SWITCH_OPTIONS[acrData.status]}
                forcedSelectedIndex={
                  ACR_SWITCH_OPTIONS[acrData.status].findIndex(
                    ({ value }) => value === acrData.status
                  )
                }
                selectedFontColor="var(--co-primary)"
                disabled={true}
              />
            </div>
          </div>
          <div className="acr-card__description">
            When enabled, your credits will automatically top up based on your preferences using your saved payment method.
            This ensures continuous usage with no interruptions to your services or workflows.
          </div>
          {isEnabled && (
            <div className="acr-card__settings">
              <div className="acr-card__settings-heading">
                Settings
              </div>
              <div className="acr-card__settings-text">
                <span className="acr-card__summary_text">
                  When my credits falls below
                </span>
                <span className="acr-card__highlight">
                  {acrData.threshold}
                </span>
                <span className="acr-card__summary_text">
                  automatically add
                </span>
                <span className="acr-card__highlight">
                  {acrData.quantity.toLocaleString()}
                </span>
                <span className="acr-card__summary_text">
                  credits by charging
                </span>
                <span className="acr-card__highlight">
                  {acrData.price.currency_symbol}
                  {acrData.price.actual_price.toFixed(2)}
                </span>
              </div>
              {acrData.coupon && (
                <div className="acr-card__coupon">
                  <span>
                   Coupon applied:
                  </span>
                  <span>
                    {acrData.coupon}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AutoCreditReplenishmentCard